// deltaCoalescer.js — FASE-11 E5-WS1-T01. Coalescer de deltas SSE por FRAME.
//
// Antes: cada token disparava updateMsg (clone O(n) do array de mensagens) +
// setLiveStatus (objeto novo mesmo com a phase inalterada) → em geração rápida
// (>100 tok/s) o React re-renderizava o workspace inteiro por token (o jank do
// achado #10). Agora os deltas acumulam no streamMsg (que já era mutado in-place
// pelo onEvent) e o flush pro store acontece 1× por frame (rAF; fallback 16ms em
// jsdom/testes). setLiveStatus usa updater que devolve o MESMO ref quando a phase
// não mudou — zero re-render de status entre tokens da mesma fase.
//
// Contrato de ordem: eventos NÃO-delta (tool_call/assistant/error) devem chamar
// flush() ANTES de processar, para o texto pendente aterrissar antes do próximo
// card. O flush é idempotente e seguro pós-turno (no-op sem pendência).

const defaultSchedule = (cb) =>
  (typeof requestAnimationFrame === 'function' ? requestAnimationFrame(cb) : setTimeout(cb, 16));
const defaultCancel = (h) =>
  (typeof cancelAnimationFrame === 'function' ? cancelAnimationFrame(h) : clearTimeout(h));

/**
 * @param {{ updateMsg: (id: any, patch: object) => void,
 *           setLiveStatus: (updater: (prev: any) => any) => void }} io
 * @param {{ schedule?: (cb: () => void) => any, cancel?: (h: any) => void }} [timers] injetável p/ teste
 */
export function createTurnDeltaFlow({ updateMsg, setLiveStatus }, { schedule, cancel } = {}) {
  const sched = schedule || defaultSchedule;
  const canc = cancel || defaultCancel;
  let pending = null;
  let handle = null;

  const run = () => {
    handle = null;
    if (!pending) return;
    const p = pending;
    pending = null;
    updateMsg(p.id, { content: p.content, reasoning: p.reasoning });
    // Só realoca o liveStatus quando a phase MUDOU (ref igual ⇒ React pula o render).
    setLiveStatus((prev) => (prev && prev.phase === p.phase && !prev.tool ? prev : { phase: p.phase }));
  };

  return {
    /** Acumula o snapshot do streamMsg mutado; agenda no MÁXIMO 1 flush por frame. */
    onDelta(streamMsg, evtType) {
      pending = {
        id: streamMsg.id,
        content: streamMsg.content,
        reasoning: streamMsg.reasoning,
        phase: evtType === 'token' ? 'gerando' : 'pensando',
      };
      if (handle == null) handle = sched(run);
    },
    /** Flush SÍNCRONO — obrigatório antes de eventos não-delta e no fim do turno. */
    flush() {
      if (handle != null) { canc(handle); handle = null; }
      run();
    },
  };
}
